import { render, staticRenderFns } from "./NumberOfTv.vue?vue&type=template&id=7c0b4d5c&scoped=true&"
import script from "./NumberOfTv.vue?vue&type=script&lang=ts&"
export * from "./NumberOfTv.vue?vue&type=script&lang=ts&"
import style0 from "./NumberOfTv.vue?vue&type=style&index=0&id=7c0b4d5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0b4d5c",
  null
  
)

export default component.exports